import React, {useEffect, useState} from 'react'
import {Field, reduxForm, FormSection, formValueSelector, change} from 'redux-form'
import { connect } from 'react-redux'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, renderers, validations } from '../../../components'
import { useSelector } from 'react-redux'
import { DevicePartReportForm } from './DevicePartReportForm'

import { FormsConstants } from '../../../state/forms'
import {getMultipleLists} from "../../../state/lists";
import {getTicketSLA} from "../../../state/slas";
import * as rest from "../../../services";

let IssueForm = ({
  dispatch,
  handleSubmit,
  pristine,
  submitting,
  reset,
  unit_part_reports,
  editMode,
  organization,
  isEditMode,
}) => {
  const { repair_type, boolean_list, unit_part, coverage_type } = useSelector(
    (state) => state.lists
  )
  const { user } = useSelector((state) => state.auth)
   const { rights } = useSelector((state) => state.userRights)
  const { is_superuser } = user
  const { ticket_slas } = useSelector((state) => state.slas)

  const [isDropOff, setIsDropOff] = useState(false);
  const loadOptions = () => {
    !ticket_slas && dispatch(getTicketSLA());
      !(repair_type && boolean_list && unit_part && coverage_type) && dispatch(
          getMultipleLists(["COVERAGE_TYPE","REPAIR_TYPE","UNIT_PART"]))
  }
  const [expectedDeliveryTime, setExpectedDeliveryTime] = useState(null)
  const get_expected_delivery_date = () => {
    new rest.OrganizationService(organization)
      .expected_delivery_date()
      .then((res) => {
        const { expected_delivery_date } = res
        setExpectedDeliveryTime(expected_delivery_date)
      })
  }

  useEffect(()=>{
      loadOptions()
      organization && !isEditMode && get_expected_delivery_date()
    setIsDropOff(rights?.filter(x=>x.tickets && x.org_type!=="ASP" && x.organization===organization).length>0)
  },[organization])
const today = new Date(); // Get the current date
const lastYear = new Date(today); // Create a new Date object based on the current date

lastYear.setFullYear(today.getFullYear() - 1)
useEffect(()=>{
     !isEditMode && expectedDeliveryTime && dispatch(
          change(
            FormsConstants.formNames.ISSUE_FORM,
            'expected_delivery_time',
            expectedDeliveryTime
          )
        )
  },[expectedDeliveryTime])
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <Field
            name="device_condition"
            label="Device Condition"
            validate={[validations.required]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12">
          <Field
            name="issue_reported_by_customer"
            label="Issue Reported By Customer"
            validate={[validations.required]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="expected_delivery_time"
            label="Expected Delivery Time"
            validate={[validations.required]}
            component={renderers.renderDateTimePicker}
            dateFormat="MMMM d, yyyy h:mm aa"
            minDate={is_superuser?lastYear:today}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="sla"
            validate={[validations.required]}
            label="SLA"
          >
            {ticket_slas &&
              ticket_slas.map((sp) => (
                <option key={sp.url} value={sp.url}>
                  {sp.name}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="coverage_type"
            label="Service Type"
            validate={[validations.required]}
          >
            {coverage_type &&
              coverage_type.map((sp) => (
                <option key={sp.url} value={sp.value}>
                  {sp.value}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className={"d-none"} md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="repair_type"
            label="Repair Type"
          >
            {repair_type &&
              repair_type.map((sp) => (
                <option key={sp.url} value={sp.value}>
                  {sp.value}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>

            <Field
            component={renderers.renderSelectField}
            as="select"
            name="expected_service_cost"
             label="Expected Service Cost"
            validate={[validations.required]}
          >
            {[0,1500,3000,3500].map((sp) => (
                <option key={sp} value={sp}>
                  {sp}
                </option>
              ))}
          </Field>

        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="expected_hardware_cost"
            label="Expected Hardware Cost"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="accessories"
            label="Accessories"
            validate={[validations.required]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="required_upgrades"
            label="Required Upgrades"
            validate={[validations.required]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>
        {isDropOff && <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
              name="po_number"
              label="PO Number"
              validate={isDropOff ? [validations.required] : []}
              component={renderers.renderField}
              type="text"
          />
        </ReactBootstrap.Col>
        }
        {isDropOff && <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
              name="drop_off_time"
              label="Drop Off Time"
              validate={isDropOff ? [validations.required] : []}
              component={renderers.renderDateTimePicker}
              dateFormat="MMMM d, yyyy h:mm aa"
          />
        </ReactBootstrap.Col>
        }

        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="is_backup_required"
            label="Backup Needed"
          >
            {
               [
      { key: 'key_boolean_list_true', value: true, text: 'Yes' },
      { key: 'key_boolean_list_false', value: false, text: 'No' },
    ].map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="is_standby_device_required"
            label="Stand By Device Needed"
            validate={[validations.required]}
          >
            { [
      { key: 'key_boolean_list_true', value: true, text: 'Yes' },
      { key: 'key_boolean_list_false', value: false, text: 'No' },
    ].map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>


        <ReactBootstrap.Col  className={"d-none"} md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            name="estimation"
            label="Estimation "
            validate={[validations.required]}
          >
            {boolean_list &&
              boolean_list.map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>
        {editMode && is_superuser && (
          <ReactBootstrap.Col md={6} xs={12} lg={6}>
            <Field
              name="inward_time"
              label="Inward Time"
              component={renderers.renderDateTimePicker}
              dateFormat="MMMM d, yyyy h:mm aa"
            />
          </ReactBootstrap.Col>
        )}
        <ReactBootstrap.Col xs={12}>
          <FormSection name="unit_part_reports">
            <ReactBootstrap.Col>
              <h3 className="mt-5">Unit Part Reports</h3>

              <DevicePartReportForm
                FormName={FormsConstants.formNames.ISSUE_FORM}
                unit_part_reports={unit_part_reports}
                unit_parts={unit_part}
                editMode={editMode}
              />
            </ReactBootstrap.Col>
          </FormSection>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
IssueForm = reduxForm({
  form: FormsConstants.formNames.ISSUE_FORM,
  initialValues:{
    repair_type:"Not Confirm",
    estimation:false,
  }
})(IssueForm)
const selector = formValueSelector(FormsConstants.formNames.ISSUE_FORM)
IssueForm = connect((state) => {
  const unit_part_reports = selector(state, 'unit_part_reports')
  const isEditMode= selector(state, 'url')
  return {
    unit_part_reports,
    isEditMode
  }
})(IssueForm)
export default IssueForm
